import {
  Slide,
  type ToastContainerProps,
  type ToastOptions,
} from 'react-toastify';

const defaultToastConfig = {
  className: '!bg-transparent p-0 w-full !h-[3.5rem] !min-h-[3.5rem] px-4 mt-2',
  closeButton: false,
};

const closeToastConfig: ToastOptions = {
  className: '!bg-transparent p-0 w-full !h-[3.5rem] !min-h-[3.5rem] px-4 mt-2',
  closeButton: true,
  autoClose: false,
};

const toastContainerProps: ToastContainerProps = {
  position: 'top-center',
  autoClose: 4000,
  hideProgressBar: true,
  closeButton: false,
  draggable: true,
  draggablePercent: 30,
  transition: Slide,
  limit: 2,
  className: 'w-full',
  toastClassName:
    'swipeable-toast bg-transparent h-[3.5rem] min-h-[3.5rem] px-4 mt-2',
};

export { closeToastConfig, defaultToastConfig, toastContainerProps };
